<div class="db-add-domain-list-dialog" *ngIf="!fromDetails">
    <h3 class="mb8">{{'text_domainAddedToYourSiteHeader' | dbText}}</h3>
    <p class="mb30">{{'text_domainAddedToYourSiteDesc' | dbText}}</p>
  <div class="ds-notification-gray mb20">
    <div>
      <i class="db-icon db-icon-credentials"></i>
      <p [innerHTML]="'text_domainAddedToYourSiteNotifDesc' | dbText"></p>
    </div>
  </div>
    <div class="db-add-domain-list-dialog__footer mt30">
        <button class="ds-btn-black" (click)="closeModal()">
            <span>{{'text_gotIt' | dbText }}</span>
        </button>
    </div>
</div>

<ng-container *ngIf="fromDetails && isDomainPointed && !zoneIssues" [ngTemplateOutlet]="isTenWebNSAndPointed"></ng-container>
<ng-container *ngIf="fromDetails && isTenWebDomain && !isDomainPointed && !zoneIssues" [ngTemplateOutlet]="isTenWebDomainAndNotPointed"></ng-container>
<ng-container *ngIf="fromDetails && !isDomainPointed && ((isTenWebDomain && !isTenWebNS) || (!isTenWebDomain && isTenWebNS) || zoneIssues)" [ngTemplateOutlet]="isNotPointed"></ng-container>
<ng-container *ngIf="fromDetails && isDomainPointed && zoneIssues" [ngTemplateOutlet]="hasZoneIssues"></ng-container>


<ng-template #isTenWebNSAndPointed>
  <div class="db-add-domain-list-dialog">
    <div class="ds-notification-gray mb25" *ngIf="isTenWebDomain && !isTenWebNS">
      <div>
        <i class="db-icon db-icon-credentials"></i>
        <p [innerHTML]="'text_domainDetailsCustomNSNotice' | dbText "></p>
      </div>
    </div>
    <h3 class="mb8">{{(isTenWebNS ? 'text_domainDetailsTenWebNSHeader' : 'text_domainDetailsCustomNSHeader' )| dbText}}</h3>
    <p class="mb30">{{(isTenWebNS ? 'text_domainAddedToYourSiteDesc' : 'text_domainDetailsCustomNSDesc')| dbText}}</p>

    <div class="db-nameservers-block" *ngIf="nameServers?.length" [ngClass]="{'db-custom-ns-not-tenweb': !isTenWebDomain && !isTenWebNS, 'ds-lazy-load': nsLoading}">
      <p class="db-custom-ns-not-tenweb-desc"
         *ngIf="!isTenWebDomain && !isTenWebNS" [innerHTML]="'text_domainDetailsCustomNSNCustomDomainNotice' | dbText"></p>

      <div class="db-nameservers-table">
          <div class="db-nameservers-block-item" *ngFor="let nameserver of nameServers; let i = index">
            <div class="db-nameservers-block-item-label">{{'text_addDomain.nameserver.label' | dbText: {number: i + 1} }}</div>
            <div class="db-nameservers-block-item-text-wrap" ngxClipboard [cbContent]="nameserver" (cbOnSuccess)="copied(i)"
                 dsTooltipSize="small" dsTooltipPosition="top"
                 dsTooltipAlign="right"
                 dsTooltipColor="black"
                 [hostClass]="'cover-all'"
                 [dsTooltip]="'<b>' + ((isTextCopied[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
              <span class="dot"></span>
              <span>{{nameserver}}</span>
              <i class="db-icon db-icon-ds-copy">
              </i>
            </div>
          </div>
      </div>
        </div>

    <div class="db-add-domain-list-dialog__footer mt30">
      <button class="ds-btn-black" (click)="closeModal()">
        <span>{{'text_gotIt' | dbText }}</span>
      </button>
    </div>
  </div>

</ng-template>
<ng-template #isTenWebDomainAndNotPointed>
  <div class="db-add-domain-list-dialog">
    <h3 class="mb8">{{'text_domainNotPointedIsTenWebDomain' | dbText}}</h3>
    <p class="mb30" [innerHTML]="'text_domainNotPointedIsTenWebDomainDesc' | dbText"></p>
    <div class="ds-notification-gray mb20">
      <div>
        <i class="db-icon db-icon-credentials"></i>
        <p [innerHTML]="'text_domainAddedToYourSiteNotifDesc' | dbText"></p>
      </div>
    </div>
    <div class="db-add-domain-list-dialog__footer mt30">
      <button class="ds-btn-black" (click)="closeModal()">
        <span>{{'text_gotIt' | dbText }}</span>
      </button>
    </div>
  </div>

</ng-template>
<ng-template #isNotPointed>
  <div class="db-add-domain-list-dialog">
    <div class="ds-notification-gray mb20">
      <div>
        <i *ngIf="!zoneIssues" class="db-icon db-icon-credentials"></i>
        <img *ngIf="zoneIssues" src="assets/images/icons/close_error_icon-red.svg" />
        <p [innerHTML]="( zoneIssues ? 'text_domainNotPointedNotTenWebDomainNotice' : 'text_domainNotPointedDNSNotice') | dbText"></p>
      </div>
    </div>

    <h3 class="mb8">{{'text_domainNotPointedIsTenWebDomain' | dbText}}</h3>
    <p class="mb30">{{(zoneIssues ? 'text_customDomainAddDNSRecordsDesc' : !isTenWebNS ? 'text_domainNotPointedIsTenWebDomainAndNotNS' : 'text_domainNotPointedIsNotTenWebDomainAndNS' )| dbText}}</p>
    <div class="db-copy-info mb50" [ngClass]="{ 'db-with-border': !zoneIssues}">
      <p *ngIf="!zoneIssues" class="mb20" [innerHTML]="(isTenWebNS ? 'text_domainNotPointedTenWebNS' : 'text_domainNotPointedCustomNS') | dbText"></p>
      <div class="db-copy-info__list-header">
        <p>{{ 'text_type' | dbText }}</p>
        <p>{{ 'text_name' | dbText }}</p>
        <p>{{ 'text_value' | dbText }}</p>
      </div>
      <ul>
        <li class="db-copy-info__list-item">
          <p>A</p>
          <div  ngxClipboard [cbContent]="domainName" (cbOnSuccess)="copied(inputHostNameA)" (click)="isTextCopied = true"
                (onTooltipHide)="isTextCopied = false"
                dsTooltipSize="small" dsTooltipPosition="top"
                [hostClass]="'cover-all'"
                dsTooltipColor="black"
                [dsTooltip]="'<b>' + ((isTextCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name" #inputHostNameA>{{domainName}}</div>
            <i class="db-icon db-icon-ds-copy"></i>
          </div>

          <div  ngxClipboard [cbContent]="ipv4Address" (cbOnSuccess)="copied(inputNameServerA)"
               (click)="isTextCopied = true"
               (onTooltipHide)="isTextCopied = false"
               dsTooltipSize="small" dsTooltipPosition="top"
               dsTooltipAlign="right"
               dsTooltipColor="black"
               [hostClass]="'cover-all'"
               [dsTooltip]="'<b>' + ((isTextCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name" #inputNameServerA>{{ipv4Address}}</div>
            <i class="db-icon db-icon-ds-copy">
            </i></div>

        </li>
        <li class="db-copy-info__list-item">
          <p>CNAME</p>

          <div ngxClipboard  [cbContent]="'www.' + domainName" (cbOnSuccess)="copied(inputHostNameCNAME)"
               (click)="isTextCopied = true"
               (onTooltipHide)="isTextCopied = false"
               dsTooltipSize="small" dsTooltipPosition="top"
               dsTooltipAlign="right"
               dsTooltipColor="black"
               [hostClass]="'cover-all'"
               [dsTooltip]="'<b>' + ((isTextCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name" #inputHostNameCNAME>{{'www.' + domainName}}</div>
            <i class="db-icon db-icon-ds-copy"></i>
          </div>

          <div ngxClipboard  [cbContent]="domainName" (cbOnSuccess)="copied(inputNameServerCNAME)"
               (click)="isTextCopied = true"
               (onTooltipHide)="isTextCopied = false"
               dsTooltipSize="small" dsTooltipPosition="top"
               dsTooltipAlign="right"
               dsTooltipColor="black"
               [hostClass]="'cover-all'"
               [dsTooltip]="'<b>' + ((isTextCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            <div class="form-control host-name" #inputNameServerCNAME>{{domainName}}</div>
            <i class="db-icon db-icon-ds-copy"></i>
          </div>

        </li>
      </ul>
    </div>

    <div class="db-add-domain-list-dialog__footer">
      <button class="ds-btn-black" (click)="closeModal()">
        <span>{{'text_gotIt' | dbText }}</span>
      </button>
    </div>
  </div>

</ng-template>
<ng-template #hasZoneIssues>
  <div class="db-add-domain-list-dialog">
    <h3 class="mb8">{{'text_domainDetailsCustomNSHeader' | dbText}}</h3>
    <p class="mb30">{{'text_domainDetailsCustomNSDesc' | dbText}}</p>
    <div class="db-add-domain-list-dialog__footer mt30">
      <button class="ds-btn-black" (click)="closeModal()">
        <span>{{'text_gotIt' | dbText }}</span>
      </button>
    </div>
  </div>

</ng-template>
